/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IItemSpecMercuryProps,
  ItemSpecMercuryWidget,
} from '@/widgets/item-spec-mercury-widget-react';
import {
  IItemSpecVenusWidgetProps,
  ItemSpecVenusWidget,
} from '@/widgets/item-spec-venus-widget-react';
import React from 'react';

// Combine both prop types into one
type HeroSectionProps = IItemSpecMercuryProps & IItemSpecVenusWidgetProps;

export const HeroSection = (props: HeroSectionProps) => {
  console.log('hero->', props);

  return (
    <>
      <ItemSpecMercuryWidget {...props} />
      <ItemSpecVenusWidget {...props} />
    </>
  );
};

HeroSection.defaultProps = {};
